import React from 'react';
import { useTransformPlaybookContext } from 'app/context/transform-playbook-context';
import PlaybookTransformationOutput from 'app/shared/components/testing-suite/PlaybookTransformationOutput';

export default function OutputEditor() {
  const { isLoading, outputEvent, outputErrors } = useTransformPlaybookContext();
  return (
    <PlaybookTransformationOutput
      loading={isLoading}
      outputEvent={outputEvent}
      outputErrors={outputErrors}
      trackingEventName="input_event_error_received"
    />
  );
}
